<div class="k-d-flex k-justify-content-center k-align-items-center gap-8">
    <rc-user-notifications></rc-user-notifications>
    <rc-user-profile-settings></rc-user-profile-settings>
</div>
